import { type ReactNode } from 'react';
interface Props {
  imageSrc: string;
  imageAlt?: string;
  title: ReactNode;
  description: ReactNode;
  notices: ReactNode[];
  footnote?: ReactNode;
  middleSlot?: ReactNode;
}
export const UpsellFeatureIntro = ({
  imageSrc,
  imageAlt = '',
  title,
  description,
  notices,
  footnote,
  middleSlot
}: Props) => {
  return <div className="flex flex-col" data-sentry-component="UpsellFeatureIntro" data-sentry-source-file="UpsellFeatureIntro.tsx">
      <div className="flex justify-center px-md pb-md pt-lg">
        <img className="max-h-[272px] w-full max-w-[458px] rounded-md border border-opacity-assistive object-cover" src={imageSrc} alt={imageAlt} />
      </div>

      <div className="flex flex-col items-center gap-md px-lg py-sm text-center">
        <div className="flex flex-col gap-xs">
          <h2 className="text-heading-sm-bold">{title}</h2>
          <p className="text-body-sm-medium text-neutral">{description}</p>
        </div>
        {middleSlot}
        <div className="flex w-full flex-col items-center gap-xs rounded-md bg-neutral px-lg py-md">
          <ul>
            {notices.map((text, i) => <li key={i} className="text-caption-lg-medium">
                • {text}
              </li>)}
          </ul>
          {footnote ? <p className="text-caption-md-medium text-alternative">
              * {footnote}
            </p> : null}
        </div>
      </div>
    </div>;
};